import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const AdminDashboard = () => {
    const { t } = useTranslation();
    return (
    <>
        <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 ad-1">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                    <h1 className="font-weight-semibold hero-heading mt-5">
                        <Trans>Streamlined <br/>Administration and Management</Trans>
                    </h1>
                    <p className="hero-para font-weight-semibold no-br">
                        <Trans>Empowering wellness coordinators with <br/>powerful tools for effective program management.</Trans>
                    </p>
                    <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-5">
                            <div className="col-12">
                                <div className="features-label red-font">
                                <Trans>Challenge Management</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading'><Trans>Effortless Program Management!</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>Effortlessly create, manage, and monitor wellness challenges for your employees.</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-7 cta-img'>
                            <div className='d-flex justify-content-center'>
                                <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1701080450/VantageFit/2023/admin_Portal-Effortless_Program_Management.webp`)} loading='lazy' alt="Effortless Program Management" width="500" height="561"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-6">
                            <div className="col-12">
                                <div className="features-label green-font">
                                <Trans>Announcements</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading'><Trans>Stay Connected with Your Audience!</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>Announce health tips, events, and updates to keep your wellness community engaged.</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-5 cta-img'>
                            <div className='col-12 d-flex justify-content-center'>
                                <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1701080449/VantageFit/2023/admin_Portal-Stay_Connected_with_Your_Audience.webp`)} loading='lazy' alt="Stay Connected with Your Audience!" width="500" height="571"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-5">
                            <div className="col-12">
                                <div className="features-label orange-font">
                                <Trans>Configuration and Customization</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading'><Trans>Tailor Wellness Programs to Your Needs!</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>Customize wellness programs, challenges, and rewards to align with your organization's unique goals.</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-7 cta-img'>
                            <div className='d-flex justify-content-center'>
                                <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1701080443/VantageFit/2023/admin_Portal-Tailor_Wellness_Programs_to_Your_Needs.webp`)} loading='lazy' alt="Tailor Wellness Programs to Your Needs" width="500" height="535"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="section-heading-top cursive">
                <h2 className="section-heading font-weight-bold text-center mb-4"><Trans i18nKey="subtextfeat7">Foster the Power of&nbsp;<span className="charmonman green-clr">Wellness</span>&nbsp;Oversight</Trans>&nbsp;!</h2>
                <div className="section-para text-center"><Trans>Empower your wellness team to effortlessly manage and customize wellness programs for your organization.</Trans></div>
            </div>
        </section>

        <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                        <Trans>Transform Your Wellness Programs Today!</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5 text-white">
                        <Trans>Simplify wellness program management with Vantage Fit.</Trans>
                    </p>
                    <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default AdminDashboard
